
export default function NotFound() {
  return <div className="text-4xl md:text-6xl font-Fredericka text-center absolute size-full py-44">PÁGINA NÃO ENCONTRADA (404)</div>;
}
